import styled from 'styled-components';

export const UnstyledButton = styled.button`
  border: none;
  background-color: transparent !important;
  padding: 0px;
`;
